<template>
	<div class="business">
		<HeaderBar></HeaderBar>
		<section>
			<div class="container">
				<div class="hg-30"></div>
				<div class="menu">
					<ul>
						<li :class="{ 'menu-on': id === 24 }" @click="menu(24)">
							管道疏通业务
						</li>
						<li :class="{ 'menu-on': id === 25 }" @click="menu(25)">
							城乡人口污染物无害化综合治理及再生资源循环利用
						</li>
						<li :class="{ 'menu-on': id === 26 }" @click="menu(26)">
							社区经济业务
						</li>
						<li :class="{ 'menu-on': id === 27 }" @click="menu(27)">
							大数据应用开发运营业务
						</li>
					</ul>
				</div>
				<div class="hg-60"></div>
				<div class="row detail mt-4">
					<div class="col-lg-12" style="min-height:58vh">
						<div v-html="article.post_content"></div>
					</div>
				</div>
			</div>
			<div class="hg-80"></div>
		</section>
		<FooterBar></FooterBar>
	</div>
</template>

<script>
import HeaderBar from '@/components/header-bar';
import FooterBar from '@/components/footer-bar';
import { baseUrl } from '../../config/config';
export default {
	name: 'business',
	components: {
		HeaderBar,
		FooterBar,
	},
	data() {
		return {
			id: parseInt(this.$route.query.id),
			article: {}, //文章详情
		};
	},
	computed: {},
	created() {
		this.getDetail();
	},
	mounted() {},
	methods: {
		menu(id) {
			this.$router.push({ path: 'business', query: { id: id } });
		},
		//获取文章详情
		getDetail() {
			let params = { do: 'detail', id: this.id };
			this.$axios
				.post(baseUrl + '/portal/Article/index', params)
				.then((res) => {
					if (res.data.code === 1) {
						this.article = res.data.data.article;
					}
				});
		},
	},
};
</script>
<style lang="scss" scope>
.business {
	.menu {
		li {
			display: inline-block;
			border: 1px solid #007bff;
			padding: 6px 20px;
			margin-right: 30px;
			transition: all 0.2s;
			border-radius: 3px;
			cursor: pointer;
			&:hover {
				background: #007bff;
				color: #fff;
			}
			&.menu-on {
				background: #007bff;
				color: #fff;
			}
		}
	}
}
</style>
